// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a0d7be1c","455":"788cb8a0","977":"d8d45ed4"}[chunkId] + ".chunk.js";
};